import { createContext, useContext } from 'react';

/**
 * Set on screens opened with no sign-in, such as a read-only view link: record names and
 * report links show as plain text, since there is nothing behind them to open.
 */
export const ReadOnlyView = createContext(false);

export function useReadOnlyView(): boolean {
  return useContext(ReadOnlyView);
}
